<template lang="pug">
  extends TableRowBase.pug
</template>

<script>
  import lodash from 'lodash';
  import TableRowBase from './TableRowBase.vue';

  export default {
    name: 'TableRowTestedToTreatmentConversionRate',
    extends: TableRowBase,
    data() {
      return {
        testsFields: [
          'tests_ige',
          'tests_mqt',
          'tests_pricks',
          'tests_sticks',
        ],
        vialsFields: [
          'scit_vials_new_patients',
          'slit_vials_new_patients',
        ],
      };
    },
    computed: {
      actualTestsRaw() {
        return lodash.reduce(this.testsFields, (sum, field) => {
          return sum + parseInt(this.curMonth[field])
        }, 0);
      },
      actualVialsRaw() {
        return lodash.reduce(this.vialsFields, (sum, field) => {
          return sum + parseInt(this.curMonth[field])
        }, 0);
      },
      actualValueRaw() {
        return this.round(this.getRatio(this.actualVialsRaw, this.actualTestsRaw), 2);
      },
      benchmarkTestsRaw() {
        return lodash.reduce(this.testsFields, (sum, field) => {
          return sum + parseInt(this.benchmarkMonth[field])
        }, 0);
      },
      benchmarkVialsRaw() {
        return lodash.reduce(this.vialsFields, (sum, field) => {
          return sum + parseInt(this.benchmarkMonth[field])
        }, 0);
      },
      benchmarkValueRaw() {
        return this.round(this.getRatio(this.benchmarkVialsRaw, this.benchmarkTestsRaw), 2);
      },
      benchmarkVariance() {
        return this.round(this.actualValueRaw - this.benchmarkValueRaw, 2);
      },
      // benchmarkValueDiff() {
      //   return (this.benchmarkValueRaw === '-') ? '-' : this.round(this.getValueDiff(this.actualValueRaw, this.benchmarkValueRaw), 2);
      // },
      benchmarkYtdVariance() {
        return this.round(this.actualYtdRaw - this.benchmarkYtdRaw);
      },
      // benchmarkYtdValueDiff() {
      //   return this.benchmarkYtdRaw === 0 ? '-' : this.round(this.getValueDiff(this.actualYtdRaw, this.benchmarkYtdRaw), 2);
      // },
      previousTestsRaw() {
        return lodash.reduce(this.testsFields, (sum, field) => {
          return sum + parseInt(this.prevYearMonth[field])
        }, 0);
      },
      previousVialsRaw() {
        return lodash.reduce(this.vialsFields, (sum, field) => {
          return sum + parseInt(this.prevYearMonth[field])
        }, 0);
      },
      previousValueRaw() {
        return this.round(this.getRatio(this.previousVialsRaw, this.previousTestsRaw), 2);
      },
      // previousYearValueDiff() {
      //   return this.prevYearNull ? 'N/A' : this.getValueDiff(this.actualValueRaw, this.previousValueRaw);
      // },
      previousYearVariance() {
        return (this.actualValue === '-') ? 0 : this.round(this.actualValueRaw - this.previousValueRaw, 2);
      },
      previousYtdVariance() {
        return this.round(this.actualYtdRaw - this.previousYtdRaw, 2);
      },
      // previousYtdValueDiff() {
      //   return this.prevYearNull ? 'N/A' : this.round(this.getValueDiff(this.actualYtdRaw, this.previousYtdRaw));
      // },

    },
    methods: {
      getCalculatedYtd(yearObj, throughMonth) {
        const tests = lodash.reduce(this.testsFields, (sum, field) => {
          return sum + this.getYtdByField(yearObj, field, throughMonth)
        }, 0);
        const vials = lodash.reduce(this.vialsFields, (sum, field) => {
          return sum + this.getYtdByField(yearObj, field, throughMonth)
        }, 0);
        return this.round(this.getRatio(vials, tests), 2);
      },
    },
  };
</script>
